import { render } from "./AdminUserTransactionsElement.vue?vue&type=template&id=bb62a8a2&scoped=true"
import script from "./AdminUserTransactionsElement.vue?vue&type=script&lang=js"
export * from "./AdminUserTransactionsElement.vue?vue&type=script&lang=js"

import "./AdminUserTransactionsElement.vue?vue&type=style&index=0&id=bb62a8a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb62a8a2"]])

export default __exports__